import VTextField from './VTextField.vue';

export { VTextField };
export default VTextField;
